/**
 * @module creditNoteStatus
 * @description A list of creditNoteStatus
 */
export const creditNoteStatus = ['successful', 'cancelled'] as const;
export type CreditNoteStatus = (typeof creditNoteStatus)[number];
